import { createElement, ReactElement, ReactNode } from "react";
import { loadScriptAsync } from "../Utils";
import HardwareScannerPreview from "./Components/HardwareScannerPreview";
import { IScanner, IScannerCode, IScanOptions } from "./Abstraction/IScanner";


export class HoneywellScanner implements IScanner {

    protected _reader: Honeywell.IBarcodeReader;
    protected _libPath: string;
    protected _curScanResult: (result: IScannerCode) => void;

    constructor(libPath: string) {
        this._libPath = libPath;
        this.isScanning = false;
        this.isOpen = false;
    }

    /**************************************/

    async closeAsync() {

        if (!this.isOpen || !this._reader)
            return;

        try {

            await this.stopScanAsync();

            await new Promise<void>((res, rej) => {

                let hasResponse = false;

                this._reader.close(result => {
                    hasResponse = true;
                    if (result.status != 0)
                        rej(result.message);
                    else
                        res();
                });

                setTimeout(() => {
                    if (!hasResponse)
                        rej("close Timeout");
                }, 500);
            });
        }
        finally {
            this._reader = null;
            this.isOpen = false;
        }

    }

    /**************************************/

    async openAsync(force = false): Promise<void> {

        if (this.isOpen && !force)
            return;

        console.debug("OPEN SCANNER");

        if (!("BarcodeReader" in window)) {
            console.debug("LOADING SCRIPTS");
            await loadScriptAsync(this._libPath + "BarcodeReader.js");


        }

        this._reader = await new Promise((res, rej) => {
            console.debug("LIST READERS");

            let hasOpenResponse = false;

            const readers = new BarcodeReaders(result => {

                if (result.status != 0) {
                    hasOpenResponse = true;
                    console.warn(result.message);
                    rej(result.message);
                }
                else {
                    console.debug("OPEN READER");
                    const reader = new BarcodeReader(readers[0], result => {

                        hasOpenResponse = true;
                        if (result.status != 0)
                            rej(result.message);
                        else 
                            res(reader);
                    });
                }
            });

            setTimeout(() => {
                if (!hasOpenResponse)
                    rej("Open Timeout")
            }, 5000)
        });

        this._reader.addEventListener("barcodedataready", this.onBarcodeDataReady.bind(this), true);

        console.debug("OPEN OK");

        this.isOpen = true;
    }

    /**************************************/

    protected onBarcodeDataReady(data: string, type: string) {
        console.debug("NEW CODE", data, type);
        if (this._curScanResult)
            this._curScanResult({
                code: data,
                type: type
            });
    }

    /**************************************/

    async scanSingleAsync(options?: IScanOptions): Promise<IScannerCode> {

        this.isScanning = true;

        console.debug("START SCANNING");

        const result = await new Promise<IScannerCode>((res, rej) => {

            this._curScanResult = (result: IScannerCode) => {
                console.debug("CUR SCAN RESULT");
                this.isScanning = false;
                this._curScanResult = null;
                res(result);
            }

            console.debug("BEGIN ACTIVATE");

            let hasResponse = false;

            this._reader.activate(true, result => {

                hasResponse = true;

                if (result.status != 0) {
                    this._curScanResult = null;
                    rej(result.message);
                }
            });

            setTimeout(() => {
                if (!hasResponse)
                    rej("Activate timeout");
            }, 1000);
        });

        console.debug("SCAN OK");

        this.isScanning = false;

        return result;
    }

    /**************************************/

    async stopScanAsync(): Promise<void> {

        if (!this._reader)
            return;

        this.isScanning = false;

        return new Promise((res, rej) => {

            let hasResponse = false;

            this._reader.activate(false, result => {

                if (this._curScanResult) {
                    this._curScanResult(null);
                    this._curScanResult = null;
                }

                hasResponse = true;

                if (result.status != 0)
                    rej(result.message);
                else
                    res();

            });

            setTimeout(() => {
                if (!hasResponse)
                    rej("activate Timeout");
            }, 500);
        });
    }


    /**************************************/

    createPreview(info?: ReactNode, isScanning?: boolean, lastScanTime?: Date): ReactElement {
        return createElement(HardwareScannerPreview, { scanner: this, info, isScanning, lastScanTime: null });
    }

    /**************************************/

    isScanning: boolean;

    isOpen: boolean;
}